import { connect } from 'react-redux';
import { compose } from 'redux';
import { getTexts } from '../redux/store/appData/texts';

export type Props = {
  getTexts: typeof getTexts;
};

const withTextUpdater: any = compose(
  connect(null, {
    getTexts,
  })
);
export default withTextUpdater;
